const area = [
  {
    name: "Jakarta",
    slug: "jakarta",
    subAreas: [
      "Jakarta Pusat",
      "Tanah Abang",
      "Senen",
      "Kemayoran",
      "Cempaka Putih",
      "Gambir",
      "Menteng",
      "Johar Baru",
      "Sawah Besar",
      "Jakarta Utara",
      "Pademangan",
      "Cilincing",
      "Penjaringan",
      "Tanjung Priok",
      "Kelapa Gading",
      "Koja",
      "Kepulauan Seribu",
      "Jakarta Selatan",
      "Mampang Prapatan",
      "Pesanggrahan",
      "Tebet",
      "Jagakarsa",
      "Pancoran",
      "Cilandak",
      "Pasar Minggu",
      "Kebayoran Baru",
      "Kebayoran Lama",
      "Setia Budi",
      "Jakarta Barat",
      "Tambora",
      "Cengkareng",
      "Kebon Jeruk",
      "Taman Sari",
      "Grogol Petamburan",
      "Palmerah",
      "Kembangan",
      "Kalideres",
      "Jakarta Timur",
      "Kramat Jati",
      "Jatinegara",
      "Cipayung",
      "Pasar Rebo",
      "Cakung",
      "Ciracas",
      "Makasar",
      "Pulo Gadung",
      "Duren Sawit",
      "Matraman",
    ],
  },
  {
    name: "Bogor",
    slug: "bogor",
    subAreas: [
      "Bogor Kota",
      "Bogor Utara",
      "Bogor Timur",
      "Bogor Selatan",
      "Cibinong",
      "Dramaga",
      "Gunung Putri",
      "Citeureup",
      "Cileungsi",
      "Tanjungsari",
      "Cigudeg",
      "Kemang",
      "Babakan Madang",
      "Bogor Tengah Kota",
      "Cariu",
      "Leuwisadeng",
      "Ciseeng",
      "Tenjo",
      "Jasinga",
      "Jonggol",
      "Bogor Barat Kota",
      "Ciawi",
      "Kelapa Nunggal",
      "Nanggung",
      "Bogor Utara Kota",
      "Ranca Bungur",
      "Bogor Timur Kota",
      "Leuwiliang",
      "Cisarua",
      "Bogor Selatan Kota",
      "Ciampea",
      "Bojonggede",
      "Parung",
      "Sukaraja",
      "Caringin",
      "Cibungbulang",
      "Cigombong",
      "Ciomas",
      "Pamijahan",
      "Sukamakmur",
      "Tanah Sereal",
      "Gunung Sindur",
      "Cijeruk",
      "Tenjolaya",
      "Rumpin",
      "Parung Panjang",
      "Sukajaya",
      "Megamendung",
      "Tajurhalang",
      "Tamansari"
    ]
  },
  {
    name: "Depok",
    slug: "depok",
    subAreas: [
      "Depok Kota",
      "Depok Utara",
      "Depok Timur",
      "Depok Selatan",
      "Cimanggis",
      "Cinere",
      "Limo",
      "Pancoran Mas",
      "Sawangan",
      "Sukmajaya",
      "Beji",
      "Cipayung",
      "Bojongsari",
      "Tapos",
      "Cilodong"
    ]
  },
  {
    name: "Tangerang",
    slug: "tangerang",
    subAreas: [
      "Jatiuwung",
      "Jambe",
      "Teluknaga",
      "Legok",
      "Tangerang",
      "Sindang Jaya",
      "Kronjo",
      "Balaraja",
      "Tigaraksa",
      "Mauk",
      "Batuceper",
      "Benda",
      "Kosambi",
      "Kelapa Dua",
      "Sukamulya",
      "Curug",
      "Cikupa",
      "Karawaci",
      "Cisoka",
      "Pakuhaji",
      "Sukadiri",
      "Panongan",
      "Gunung Kaler",
      "Cibodas",
      "Cisauk",
      "Pagedangan",
      "Mekar Baru",
      "Jayanti",
      "Solear",
      "Larangan",
      "Penang",
      "Cipondoh",
      "Rajeg",
      "Periuk",
      "Pasar Kemis",
      "Sepatan Timur",
      "Kresek",
      "Kemiri",
      "Neglasari",
      "Karang Tengah",
      "Sepatan",
      "Ciledug",
    ]
  },
  {
    name: "Tangerang Selatan",
    slug: "tangerang-selatan",
    subAreas: [
      "Setu",
      "Pamulang",
      "Serpong",
      "Ciputat Timur",
      "Ciputat",
      "Serpong Utara",
      "Pondok Aren",
    ]
  },
  {
    name: "Bekasi",
    slug: "bekasi",
    subAreas: [
      "Bekasi Kota",
      "Bekasi Utara",
      "Bekasi Timur",
      "Bekasi Barat",
      "Bekasi Selatan",
      "Medan Satria",
      "Bantar Gebang",
      "Rawalumbu",
      "Jatiasih",
      "Mustika Jaya",
      "Babelan",
      "Sukatani",
      "Pebayuran",
      "Bojongmangu",
      "Kedung Waringin",
      "Setu",
      "Cikarang Selatan",
      "Cibarusah",
      "Cibitung",
      "Cikarang Pusat",
      "Cikarang Utara",
      "Cikarang Barat",
      "Serang Baru",
      "Cikarang Timur",
      "Tambun Utara",
      "Pondok Melati",
      "Pondok Gede",
      "Jati Sampurna",
      "Tambun Selatan",
      "Cabangbungin",
      "Muara Gembong",
      "Karangbahagia",
      "Tarumajaya",
      "Tambelang",
      "Sukawangi",
      "Sukakarya",
    ]
  },
  {
    name: "Karawang",
    slug: "karawang",
    subAreas: [
      "Karawang Barat",
      "Karawang Timur",
      "Rengasdengklok",
      "Klari",
      "Jatisari",
      "Rawamerta",
      "Banyusari",
      "Batujaya",
      "Cilamaya Kulon",
      "Majalaya",
      "Tirtamulya",
      "Tirtajaya",
      "Talagasari",
      "Cibuaya",
      "Purwasari",
      "Tegalwaru",
      "Cilamaya Wetan",
      "Cikampek",
      "Kotabaru",
      "Cilebar",
      "Tempuran",
      "Pangkalan",
      "Jayakerta",
      "Lemahabang",
      "Pedes",
      "Telukjambe Barat",
      "Kutawaluya",
      "Ciampel",
      "Telukjambe Timur",
      "Pakisjaya",
    ]
  },
  {
    name: "Bandung",
    slug: "bandung",
    subAreas: [
      "Ranca Bali",
      "Regol",
      "Arjasari",
      "Baleendah",
      "Antapani Cicadas",
      "Cicendo",
      "Bojongloa Kaler",
      "Sumur Bandung",
      "Babakan Ciparay",
      "Cinambo",
      "Cicalengka",
      "Kiaracondong",
      "Ciparay",
      "Cangkuang",
      "Banjaran",
      "Pangalengan",
      "Katapang",
      "Bandung Kidul",
      "Batununggal",
      "Majalaya",
      "Nagreg",
      "Solokan Jeruk",
      "Pameungpeuk",
      "Rancaekek",
      "Bojongsoang",
      "Kutawaringin",
      "Lengkong",
      "Andir",
      "Cimaung",
      "Dayeuhkolot",
      "Bandung Kulon",
      "Astana Anyar",
      "Bojongloa Kidul",
      "Ibun",
      "Cimeunyan",
      "Kertasari",
      "Cileunyi",
      "Pasirjambu",
      "Cibeunying Kidul",
      "Cibeunying Kaler",
      "Ujung Berung",
      "Paseh",
      "Margaasih",
      "Cikancung",
      "Bandung Wetan",
      "Buahbatu Margacinta",
      "Pacet",
      "Cilengkrang",
      "Gedebage",
      "Soreang",
      "Panyileukan",
      "Cibiru",
      "Coblong",
      "Rancasari",
      "Sukajadi",
      "Arcamanik",
      "Cidadap",
      "Ciwidey",
      "Sukasari",
      "Mandalajati",
      "Margahayu",
    ]
  }
];

export default area;